import { useLocation } from 'react-router-dom'
import moment from "moment";

import { contractStatuses, accesses, mappedLetters, paymentErrors, limitDaysForProlong, creditDealTypeCode, wordForms, dealDurationType } from './data-constants'
import { USER_INFO } from '../constants/localStorageConstants'
import { timePeriods } from './data-constants';

// A custom hook that builds on useLocation to parse the query string for you.
export const useQuery = () => {
  return new URLSearchParams(useLocation().search)
}

// cancels the transition to the next line
export const handleKeyPressTA = (e) => {
  if (e.key === 'Enter') {
    e.preventDefault();
  }
}

export const formatDate = (dateStr) => {
  if (dateStr.includes('-')) {
    return moment(dateStr, 'YYYY-MM-DD').format('D MMMM YYYY');
  } else if (dateStr.includes('.')) {
    return moment(dateStr, 'DD.MM.YYYY').format('D MMMM YYYY');
  }
  return dateStr;
};

export function getQuarterDates(quarter) {
  const currentDate = moment();
  const currentYear = currentDate.year();
  const quarterStartMonth = 3 * (quarter - 1);
  const quarterStartDate = moment({ year: currentYear, month: quarterStartMonth, day: 1 });
  const quarterEndDate = moment({ year: currentYear, month: quarterStartMonth + 2 }).endOf('month');

  return { startDate: quarterStartDate.format('YYYY-MM-DD'), endDate: quarterEndDate.format('YYYY-MM-DD') };
}

// function to go to the next input field
export const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      const inputs = e.target.form.elements;
      const currentIndex = Array.prototype.indexOf.call(inputs, e.target);
      let nextIndex = currentIndex + 1;

      while (inputs[nextIndex] && inputs[nextIndex].disabled) {
        nextIndex++;
      }

      const nextInput = inputs[nextIndex];
      if (nextInput) {
        nextInput.focus();
      }
    }
};

// range time
export function isCurrentTimeInRange(timeFrom, timeTo) {
  const currentTime = moment();
  const startTime = moment(timeFrom, 'HH:mm:ss');
  const endTime = moment(timeTo, 'HH:mm:ss');

  if (startTime.isAfter(endTime)) {
    return currentTime.isSameOrAfter(startTime) || currentTime.isSameOrBefore(endTime);
  } else {
    return currentTime.isBetween(startTime, endTime, null, '[]');
  }
}

export const cashValue = (value, isNonCashOperationCrediton) => {
  switch (value) {
    case 'CASH':
      return 'нал.'
    case 'NON_CASH':
      return isNonCashOperationCrediton ? 'б/нал касса' : 'б/нал.'
    case 'NON_CASH_ACCOUNT':
      return 'б/нал\nр/счет'
    case 'BANK_TRANSACTION': {
      return 'Ерип'
    }
    default:
      return ''
  }
}

export const returnEndStr = (arg, word = wordForms.dayForm) => {
  const count = Number(arg);
  const digitValue = count % 10;
  const teenValue = count % 100;

  if (isNaN(count)) {
    return `- ${word.plural}`;
  }

  if (count === 0 || digitValue === 0 || (teenValue >= 11 && teenValue <= 14)) {
    return `${count} ${word.plural}`;
  } else if (digitValue === 1) {
    return `${count} ${word.singular}`;
  } else if (digitValue >= 2 && digitValue <= 4) {
    return `${count} ${word.few}`;
  } else {
    return `${count} ${word.plural}`;
  }
};

export const dropDecimals = (value, decimals, minus = false) => {
  if (+decimals === 0) {
    return value.trim()
      .split('')
      .filter((i) => {
        return isFinite(i)
      }).join('')
  }
  const regExp = minus
    ? `^(\\-?)?(^(\\-?\\d{0,14}(\\.|,))\\d{0,${decimals}})|^(\\-?\\d{0,14})`
    : `(^(\\d{0,14}(\\.|,))\\d{0,${decimals}})|^(\\d{0,14})`
  const data = value.trim()
    .split('')
    .filter((i, idx) => {
      if (!idx) {
        const isNum = isFinite(i)
        return (i === '-') || isNum
      }
      return i
    }).join('')
    .match(regExp, 'g')[0]

  if (data.split('').find(i => i === ',')) {

    return data.split('').map(i => i === ',' ? '.' : i).join('')
  }

  return data
}

export const translateErrorMessage = str => {
  if (str) {
    if (str === 'You have reach maximum possible deal extension Date') {
      return 'Вы достигли масимальной даты продления'
    } else if (str === 'deal is overdue, selected extension date later then endDate') {
      return 'Договор просрочен. Но выбранная дата продления раньше даты окончания'
    } else return 'Договор активен. Выбранная дата продления меньше даты окончания договора'
  }
}

export const returnTextStatus = (status) => {
  const v = contractStatuses[status] || contractStatuses['UNKNOWN']
  return v.name
}

export const returnStatus = (status, toggle) => {
  switch (status) {
    case 'canceled':
      const statuses = [
        contractStatuses.CANCELED.param, contractStatuses.CLOSED.param,
        contractStatuses.INVENTORY.param, contractStatuses.WITHDRAWAL.param,
        contractStatuses.SALED_STORE.param,contractStatuses.UNNECESSARY.param,
        contractStatuses.GOHRAN.param, contractStatuses.SALED_GOHRAN.param,
        contractStatuses.GARAGE_ARCHIVE.param
      ]
      return toggle ? [...statuses, contractStatuses.STORE.param].join(',') : statuses.join(',')
    case 'all':
      return ''
    case 'active': {
      const statuses = [
        contractStatuses.ACTIVE.param, contractStatuses.EXPIRED.param,
        contractStatuses.TOTRANSFER.param, contractStatuses.RETENTION.param,
        contractStatuses.GARAGE.param
      ]
      return toggle ? statuses.join(',') : [...statuses, contractStatuses.STORE.param].join(',')
    }
    default:
      return ''
  }
}

export const groupByLetters = (list, useSecondLetter) => {
  if (list) {
    const letter = []

    list.forEach(el => {
      if (useSecondLetter) {
        if (!letter.includes(el.value.slice(0, 2))) {
          letter.push(el.value.slice(0, 2))
        }
      } else {
        if (!letter.includes(el.value[0])) {
          letter.push(el.value[0])
        }
      }
    });
    const result = letter.sort().map(i => ({
      letter: i,
      groups: list.filter(({ value }) => {
        if (i?.length === 2) {
          return value.slice(0, 2) === i
        }
        return value[0] === i
      }).map(({ value, count }) => ({ value, label: `${value} (${count})` }))
    }))

    return result
  }
}

export const returnKeys = obj => Object.keys(obj)

export const containsNotActiveNotProlong = arr => {
  let result = false
  for (const deal of arr) {
    if (deal.status !== contractStatuses.ACTIVE.param &&
      deal.status !== contractStatuses.EXPIRED.param) {
      result = true
      break
    }
  }
  return result
}

export const containsNotActiveNotExpiredNotRetention = arr => {
  let result = false
  for (const deal of arr) {
    if (deal.status !== contractStatuses.ACTIVE.param &&
      deal.status !== contractStatuses.EXPIRED.param &&
      deal.status !== contractStatuses.RETENTION.param)
    {
      result = true
      break
    }
  }
  return result
}

const isLimitReached = (
  deal,
  limitDays,
  isNewGlobalProlong,
  isExtensionThreeImplementaition
) => {
  if (!deal?.endDate) return false;

  let isLimitDaysReached = false;
  let isStandardLimitReached = false;

  if (isNewGlobalProlong) {
    isLimitDaysReached = moment(deal.endDate)
      .add(1, 'days')
      .diff(moment(), 'days') >= limitDays;
  }

  if (!isNewGlobalProlong && isExtensionThreeImplementaition) {
    isStandardLimitReached = Boolean(
      deal.days && 
      moment()
        .add(deal.days, 'days')
        .isSame(moment(deal.endDate), 'days')
    );
  }
  return isLimitDaysReached || isStandardLimitReached || Boolean(deal.isInterestLimitReached);
};

export const containsProlongLimitDaysDeal = ({
  selectedDeals = [],
  clientContract,
  isNewGlobalProlong, 
  isExtensionThreeImplementaition
}) => 
  selectedDeals.some(deal => isLimitReached(deal, limitDaysForProlong, isNewGlobalProlong, isExtensionThreeImplementaition)) ||
  (clientContract && isLimitReached(clientContract, limitDaysForProlong, isNewGlobalProlong, isExtensionThreeImplementaition));

export const filtersSelectedDeals = (arr) => {
  const dealIds = [];
  const transferIds = [];

  arr.forEach((i) => {
    if (i?.deal && i.deal && i.deal?.deal.length) {
      if (i.checked) {
        const filterDealsLength = i.deal.deal.filter((item) => item.checked).length;
        if (
          filterDealsLength &&
          filterDealsLength === i.deal.deal.length &&
          i.deal.totalPages === 1
        ) {
          return i.deal.deal.forEach((item) => {
            if (item.checked) dealIds.push(item.id);
          });
        } else {
          transferIds.push(i.transferId);
        }
      }
      i.deal.deal.forEach((item) => {
        if (item.checked) dealIds.push(item.id);
      });
    } else {
      transferIds.push(i.transferId);
    }
  });

  return { dealIds, transferIds }
}


export function validateDelayDays(delayDays) {
  if (delayDays.to !== null) {
    if (+delayDays.from > +delayDays.to) {
      return 'Значение "От" не может быть больше чем значение "До"';
    }
    if (+delayDays.to > 10000) {
      return 'Значение "От" и "До" должно быть не больше 10000';
    }
    if (+delayDays.to < 1) {
      return 'Значение "От" и "До" должно быть не меньше 1';
    }
  }
  if (delayDays.from !== null) {
    if (+delayDays.from > 10000) {
      return 'Значение "От" и "До" должно быть не больше 10000';
    }
    if (+delayDays.from < 1) {
      return 'Значение "От" и "До" должно быть не меньше 1';
    }
  }
  return null;
}

export const transactionDate = (transaction) => {
  if (transaction && transaction.date && transaction.createDate) {
    let date = moment(transaction.date);
    let createDate = moment(transaction.createDate);
    if (createDate.isSame(date, 'day')) {
      return createDate.format('DD.MM.YYYY, HH:mm')
    } else {
      return date.format('DD.MM.YYYY')
    }
  }
  return moment(transaction.date).format('DD.MM.YYYY');
}

export const checkForPurity = deal => !!deal.positions[0]?.grossWeight

export const generatePrintedForm = (data, filename, type) => {
  const byteCharacters = atob(data.content);
  const byteNumbers = new Array(byteCharacters.length);
  for (let i = 0; i < byteCharacters.length; i++) {
    byteNumbers[i] = byteCharacters.charCodeAt(i);
  }
  const byteArray = new Uint8Array(byteNumbers);

  if (type === "xlsx") {
    const file = new File([byteArray], filename || `filename.xlsx`, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
    const fileURL = URL.createObjectURL(file);

    const downloadLink = document.createElement("a");
    downloadLink.href = fileURL;
    downloadLink.download = filename || 'filename.xlsx';
    downloadLink.target = '_blank';
    downloadLink.click();
  } else if ( type === "json" ) {
    const file = new File([byteArray], filename || `filename.json`, { type: 'application/json' })
    const fileURL = URL.createObjectURL(file);

    const downloadLink = document.createElement("a");
    downloadLink.href = fileURL;
    downloadLink.download = filename || 'filename.json';
    downloadLink.target = '_blank';
    downloadLink.click();
  } else if ( type === "xml" ) {
    const file = new File([byteArray], filename || `filename.xml`, { type: 'application/xml' })
    const fileURL = URL.createObjectURL(file);

    const downloadLink = document.createElement("a");
    downloadLink.href = fileURL;
    downloadLink.download = filename || 'filename.xml';
    downloadLink.target = '_blank';
    downloadLink.click();
  } else {
    const file = new File([byteArray], filename || `report.pdf`, { type: 'application/pdf' });
    const fileURL = URL.createObjectURL(file);

    const downloadLink = document.createElement("a");
    downloadLink.href = fileURL;
    downloadLink.target = '_blank';
    downloadLink.click();
  }
}

export const getUserFromLocalStorage = () => JSON.parse(localStorage.getItem(USER_INFO))

export const calculationAccess = (accessForRoles) => {
  const userRoles = getUserFromLocalStorage()

  if (userRoles) {
    let access = false;
    for (const role of accessForRoles) {
      if (userRoles.roles.find(i => i === role)) {
        access = true;
        break;
      }
    }

    return access;
  } else {
    return null
  }
}

export const reduxCalculationFeatures = (arrFeatures) => {
  let transformedObject
  if (arrFeatures) {
    transformedObject = arrFeatures.reduce((result, item) => {
      result[item.name] = item.enabled;
      return result;
    }, {});
  }
  return transformedObject
}

export const permissionsAccess = (accessForPermissions) => {
  const userPermissions = getUserFromLocalStorage()

  if (userPermissions) {
    const access = userPermissions?.permissions.find((u)=> u.permission === accessForPermissions )
    return !!access;
  }
}

export const reduxCalculationAccess = (arrRoles) => {
  let userRoles

  if (arrRoles) {
    userRoles = arrRoles
  } else {
    userRoles = getUserFromLocalStorage().roles
  }

  const userAccess = {}

  for (const [key, value] of Object.entries(accesses)) {
    userAccess[key] = value.find(i => userRoles.includes(i)) ?? null
  }

  return userAccess
}

export const convertFacets = (facets) => {
  return facets.map((facet) => ({
    value: facet.value,
    count: facet.count,
    checked: false,
  }));
}

export const convertDocument = (client) => {
  if (client.doc) {
    const document = client.doc.find((doc)=> doc.active)
    if (document) {
      const { country, documentType, documentNumber } = document;
      return `${documentType} ${country.toLowerCase() === 'беларусь' ? ' РБ' : ' другого государства'
      } ${documentNumber}`;
    }
  }
  return 'Документ просрочен';
}

export const prepareClients = (clientsList) => {
  if (!clientsList.length) {
    return []
  }

  return clientsList.map((client) => {
    return {
      ...client,
      fullName: `${client.lastName} ${client.firstName}${!!client.middleName ? (' ' + client.middleName) : ''}`,
      document: convertDocument(client),
      contact: client.contact ? [...client.contact] : '',
    };
  });
}

export const toLocalDate = (momentDate) => {
  return momentDate ? momentDate.format('yyyy-MM-DD') : null;
}

export const getActiveFacets = (list, selected) => {
  return list ? list.filter((f) => selected[f.value]).map((f) => f.value) : [];
}

export const buildRequest = (state, filter) => {
  const from = toLocalDate(filter.timeRange.startDate);
  const to = toLocalDate(filter.timeRange.endDate);
  const cashboxes = getActiveFacets(state.cashboxes, filter.selectedCashboxes);
  const branches = getActiveFacets(state.branches, filter.selectedBranches);
  return {
    size: filter.pageRange,
    from: (filter.currentPage - 1) * state.pageRange,
    sort: 'lastName.keyword,firstName.keyword,middleName.keyword,id.keyword',
    order: 'desc',
    term: filter.term, // поисковый запрос
    ranges: {
      total: { start: filter.amountRangeMinMax[0], end: filter.amountRangeMinMax[1] }, // сумма микрозайма
      count: { start: filter.requestsRangeMinMax[0], end: filter.requestsRangeMinMax[1] }, // количество обращений
      creationDate: { start: from, end: to }, // даты
    },
    facets: [
      { name: 'cashbox', values: cashboxes }, // отделения
      { name: 'branch', values: branches }, // филиалы
    ],
  };
}

export const methodsSearchDeals = {
  toLocalDate: (momentDate) => {
    return momentDate ? momentDate.format('yyyy-MM-DD') : null;
  },
  toDisplayDate: (momentDate) => {
    return momentDate ? momentDate.format('DD-MM-yyyy') : null;
  },
  getActiveFacets: (list, selected) => {
    return list.filter((f) => selected[f.value]).map((f) => f.value);
  },
  sort: (options) => {
    return options.sort(({ value: aValue }, { value: bValue }) => {
      return aValue === bValue ? 0 : aValue > bValue ? 1 : -1;
    });
  },
  buildRequest: (facets, filter) => {
    return {
      size: filter.pageRange,
      from: (filter.currentPage - 1) * filter.pageRange,
      sort: 'dealNumber.keyword',
      order: 'desc',
      term: filter.term,
      ranges: {
        creationDate: {
          start: methodsSearchDeals.toLocalDate(filter.timeRange.startDate),
          end: methodsSearchDeals.toLocalDate(filter.timeRange.endDate),
        },
        amount: {start: filter.amountRange[0], end: filter.amountRange[1]}
      },
      facets: [
        { name: 'cashbox', values: methodsSearchDeals.getActiveFacets(facets.cashbox, filter.cashbox) },
        {
          name: 'purityName',
          values: methodsSearchDeals.getActiveFacets(facets.purityName, filter.purityName),
        },
        {
          name: 'purityType',
          values: methodsSearchDeals.getActiveFacets(facets.purityType, filter.purityType),
        },
        { name: 'dealType', values: methodsSearchDeals.getActiveFacets(facets.dealType, filter.dealType) },
        { name: 'carBrand', values: methodsSearchDeals.getActiveFacets(facets.carBrand, filter.carBrand) },
        { name: 'carDate', values: methodsSearchDeals.getActiveFacets(facets.carDate, filter.carDate) },
        { name: 'status', values: methodsSearchDeals.getActiveFacets(facets.status, filter.status) },
        { name: 'branch', values: methodsSearchDeals.getActiveFacets(facets.branch, filter.branch) },
      ],
    };
  },
};

export const createArrayYears = () => {
  const arrYears = [];
  const year = moment().year();

  for (let index = 2022; index <= year; index++) {
    arrYears.push(index);
  }

  return arrYears;
};

export const createArrayYearsFromNowToPast = (lastYearInArray) => {

  const todayYear = +moment().utc().format('YYYY');
  let years = [];
  for ( let i = todayYear; i >= lastYearInArray; i-- ) {
    years.push(i);
  }

  return years;
};

export const dataYears = (data, viewReportsMonths, viewReportsQuarter) => {
  const selectedYear = data.value;
  const currentYear = moment().year();

  let months = null;
  let quarter = null;
  let year = null;

  if (currentYear > selectedYear) {
    year = [
      {
        title: `${selectedYear} - год`,
        dateFrom: `${selectedYear}-01-01`,
        dateTo: `${selectedYear}-12-31`,
        type: 'xlsx',
        viewReport: viewReportsQuarter,
        period: 'yearly'
      },
    ];

    months = Object.values(timePeriods.months).map((i, ind) => {
      const numberMonth = ind + 1 < 10 ? `0${ind + 1}` : `${ind + 1}`;
      const totalDay = moment(`${selectedYear}-${numberMonth}`, 'YYYY-MM').daysInMonth();
      return {
        ...i,
        dateFrom: `${selectedYear}-${numberMonth}-01`,
        dateTo: `${selectedYear}-${numberMonth}-${totalDay}`,
        viewReport: viewReportsMonths,
        period: 'month'
      };
    });

    quarter = Object.values(timePeriods.quarter).map((i, ind) => {
      const fromMonth = ind
        ? ind * 3 + 1 < 10
          ? `0${ind * 3 + 1}` :
          `${ind * 3 + 1}`
        : '01';
      const toMonth = (ind + 1) * 3 < 10 ? `0${(ind + 1) * 3}` : (ind + 1) * 3;
      const totalDay = moment(`${selectedYear}-${toMonth}`, 'YYYY-MM').daysInMonth();

      return {
        ...i,
        dateFrom: `${selectedYear}-${fromMonth}-01`,
        dateTo: `${selectedYear}-${toMonth}-${totalDay}`,
        viewReport: viewReportsQuarter,
        period: 'quarter'
      };
    });
  } else {
    year = [
      {
        title: `${currentYear} - год`,
        dateFrom: `${currentYear}-01-01`,
        dateTo: `${moment().format('YYYY-MM-DD')}`,
        type: 'xlsx',
        viewReport: viewReportsQuarter,
        period: 'yearly'
      },
    ];

    const currentMonth = moment().month();

    months = Object.values(timePeriods.months)
      .filter((i, ind) => ind <= currentMonth)
      .map((i, ind) => {
        if (currentMonth > ind) {
          const numberMonth = ind + 1 < 10 ? `0${ind + 1}` : `${ind + 1}`;
          const totalDay = moment(`${currentYear}-${numberMonth}`, 'YYYY-MM').daysInMonth();

          return {
            ...i,
            dateFrom: `${currentYear}-${numberMonth}-01`,
            dateTo: `${currentYear}-${numberMonth}-${totalDay}`,
            viewReport: viewReportsMonths,
            period: 'month'
          };
        } else {
          const numberMonth = ind + 1 < 10 ? `0${ind + 1}` : `${ind + 1}`;

          return {
            ...i,
            dateFrom: `${currentYear}-${numberMonth}-01`,
            dateTo: `${moment().format('YYYY-MM-DD')}`,
            viewReport: viewReportsMonths,
            period: 'month'
          };
        }
      });

    const currentQuarter = moment().quarter();

    quarter = Object.values(timePeriods.quarter)
      .filter((i, ind) => ind + 1 <= currentQuarter)
      .map((i, ind) => {
        const fromMonth = ind * 3 + 1;

        if (currentMonth === fromMonth) {
          return {
            ...i,
            dateFrom: `${selectedYear}-${ind ? ind * 3 + 1 < 10
              ? `0${ind * 3 + 1}` :
              `${ind * 3 + 1}` : '01'}-01`,
            dateTo: `${moment().format('YYYY-MM-DD')}`,
            viewReport: viewReportsQuarter,
            period: 'quarter'
          };
        } else {
          const toMonth = (ind + 1) * 3 < 10 ? `0${(ind + 1) * 3}` : (ind + 1) * 3;
          const totalDay = moment(`${selectedYear}-${toMonth}`, 'YYYY-MM').daysInMonth();

          return {
            ...i,
            dateFrom: `${selectedYear}-${ind ? ind * 3 + 1 < 10
              ? `0${ind * 3 + 1}` :
              `${ind * 3 + 1}` : '01'}-01`,
            dateTo: `${selectedYear}-${toMonth}-${totalDay}`,
            viewReport: viewReportsQuarter,
            period: 'quarter'
          };
        }
      });
  }

  return {
    months,
    quarter,
    year,
  };
};

export const translationRuEnSameLetters = (event, func, fieldName, upperCase = false) => {

  const cursor = event.target.selectionStart

  event.persist();
  let text;
  if(upperCase) {
    text = event.target.value.trim().toUpperCase();
  } else {
    text = event.target.value;
  }
  let result = '';
  for (let i = 0; i < text.length; i++) {
    let letter = text.charAt(i);
    if (mappedLetters[letter]) {
      result += mappedLetters[letter];
    } else {
      result += letter;
    }
  }
  func(fieldName, result);

  event.target.setSelectionRange(cursor, cursor)
};

export function calculateAge(date) {
  let result = ''
  if (date) {
    const years = moment().diff(date, 'years');

    if (years % 10 === 1) {
      result = `${years} год`
    } else if (years % 10 === 2 || years % 10 === 3 || years % 10 === 4) {
      result = `${years} года`
    } else {
      result = `${years} лет`
    }
  } else {
    result = null
  }
  return result
}

export const preventPlusMinusChars = e => {
  const invalidChars = ['+', '-', 'E','e']
  if (invalidChars.includes(e.key)) {
    e.preventDefault()
  }
}

export const getDocumentName = (client) => {
  if (client.document) {
    const { documentType, documentNumber, startDate, authority } = client.document;
    return `${documentType} ${documentNumber}, лн ${client.personal}, выдан ${moment(startDate).format('DD.MM.YYYY')} ${authority}`;
  }
  return '';
};

export const extractValue = (obj) => obj?.value;

export const formattingEndDealDate = (date) => moment(date).add(1, 'days').format('YYYY-MM-DD')

export const formattingDate = (date) => moment(date).format('YYYY-MM-DD')

export const groupSelectedOptions = (selectedOptions, options, groupedSelected) => {
  selectedOptions.forEach((option) => {
    const group = options.find((grp) =>
        grp.group === option.group ||
        grp.options?.some((opt) => opt.value === option.value)
    );
    groupedSelected[group.group].push(option);
  });
  return groupedSelected;
};

export const getExpectedMessage = (isNonCashOperationCrediton, paymentInputs) => {
  if (isNonCashOperationCrediton && !paymentInputs.length) {
      return paymentErrors.PAYMENT_TYPE_REQUIRED;
  } else if (isNonCashOperationCrediton) {
      return paymentErrors.AMOUNT_MISMATCH;
  } else {
      return paymentErrors.NON_CASH_ERROR;
  }
}

export const getDaysUntilEndDate = (calculateEndDate) => {
  const today = moment().startOf('day');
  const endDate = moment(calculateEndDate).startOf('day');

  const daysUntilEndDate = endDate.diff(today, 'days') + 1; 
  return daysUntilEndDate;
};

export const getValidDurationCoupons = (coupons, calculateEndDate, calculateEndMonths, calculateFirstPaymentDate) => {
    const isHybrid = Boolean(calculateFirstPaymentDate);
  const isAnnuity = Boolean(calculateFirstPaymentDate || calculateEndMonths);
  const endDate = isHybrid ? calculateFirstPaymentDate : calculateEndDate;
  const daysUntilEndDate = endDate ? getDaysUntilEndDate(endDate) : null;
  
  return coupons.filter(coupon => 
    coupon.couponRowList.some(couponRow => {
      if (isHybrid) {
        return (
          daysUntilEndDate >= coupon.minDuration &&
          daysUntilEndDate <= coupon.maxDuration &&
          calculateEndMonths >= couponRow.minAnnuityDuration &&
          calculateEndMonths <= couponRow.maxAnnuityDuration
        );
      } else {
        const duration = isAnnuity ? calculateEndMonths : daysUntilEndDate;
        return duration >= coupon.minDuration && duration <= coupon.maxDuration;
      }
    })
  );
};

export const getCodeFromDeals = (selectedDeals) => {
  let code = creditDealTypeCode.MFO_AGREEMENT_DEPOSIT_THINGS;

  for (const { positions, type } of selectedDeals) {
      const { storageInCashBox } = positions[0]; 

      if (type === 'CARS' && !storageInCashBox) {
          code = creditDealTypeCode.MFO_PLEDGE_AGREEMENT;
          break; 
      } 
  }

  return code;
};

export const splitOptionsByGroup = (selectedOptions, dealOptions) => {
  return selectedOptions.reduce((acc, currentOption) => {
    for (const optionGroup of dealOptions) {
      const matchedOption = optionGroup.options.find(option => option.value === currentOption.value);
      if (matchedOption) {
        acc[optionGroup.group].push(matchedOption);
      }
    }
    return acc;
  }, { typeDeal: [], typeDuration: [] });
};

export const returnAnnuityDealType = (type) => {
  let typeDeal = '';
  switch (type) {
    case 'LONG':
      typeDeal = 'д/ср'
      break
    case 'SHORT':
      typeDeal = 'к/ср'
  }
  return typeDeal;
}

export const isProlongAnnuity = (deal) => {
  const longDeal = "LONG";
  let result;
  for (let i = 0; i < deal.length; i++) {
    if (deal[i].dealDuration === longDeal) {
      result = true;
    }
  }
  return result;
}

export const determineStatus = (typeDeal) => {
  const hasLongDeal = typeDeal.some(deal => deal.value === dealDurationType.LONG);
  const hasShortDeal = typeDeal.some(deal => deal.value === dealDurationType.SHORT);

  if (hasLongDeal) {
    return 'EXPIRED,EXPIRED_PAYMENT';
  } else if (hasShortDeal) {
    return 'EXPIRED';
  }

  return 'EXPIRED';
}

export const containsDifferentDealDurationTypes = (deals = []) => {
  if (!deals.length) return false;
  const dealsDurationTypes = new Set(deals.map(deal => deal.dealDuration));
  return dealsDurationTypes.size > 1;
};
